import { Role } from 'src/app/data/intervenant/models/enums/roles.enum';

export class BaseComponent {
    public ROLE = Role;
}
